import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { TextLink } from 'baby-design'
// eslint-disable-next-line import/no-extraneous-dependencies
import { DownloadPDF } from 'baby-design/icons'

import { registryGiftTrackerCSVPath } from 'lib/urls'

const DownloadCSV: FC = () => (
  <TextLink
    underline
    href={registryGiftTrackerCSVPath}
    icon={{
      side: 'left',
      icon: <DownloadPDF />,
      size: 'sm',
    }}
    size="sm"
  >
    Thank you list
  </TextLink>
)

export default DownloadCSV
